





























































































import {Vue, Component} from 'vue-property-decorator'
import getConnection from "@/utils/signalr_connection";

@Component({components: {}})
export default class Messages extends Vue {
  messages = [];

  async created() {
    getConnection().on('receivedMessageFromAgent', this.getRecentMessages);
    await this.getRecentMessages();
  }

  async getRecentMessages() {
    const {data} = await this.$http.get("/api/GetRecentMessages");
    this.messages = data;
  }

  destroyed() {
    getConnection().off('receivedMessageFromAgent', this.getRecentMessages);
  }
}
